import React from 'react';

import { AvatarRadius } from '@/ui/Avatars/Avatar';

import { classNames } from '@/utils/classnames';

interface SkeletonBaseProps {
  height?: number | string;
  width?: number | string;
  children?: React.ReactNode;
  className?: string;
}

interface TextSkeletonProps extends SkeletonBaseProps {
  lines?: number;
  lineClassName?: string;
}

interface AvatarSkeletonProps extends Omit<SkeletonBaseProps, 'height' | 'width'> {
  size: number;
  radius?: AvatarRadius;
}

export function AvatarSkeleton({
  size,
  className,
  radius = '100%',
  children,
}: AvatarSkeletonProps) {
  return (
    <div
      className={classNames('animate-pulse inline-block bg-token-gray-400', className)}
      style={{ height: size, width: size, borderRadius: radius }}
    >
      {children}
    </div>
  );
}

export function TextSkeleton({
  children,
  height,
  lines = 1,
  width,
  className,
  lineClassName,
}: TextSkeletonProps) {
  return (
    <div
      style={{ width }}
      className={classNames('animate-pulse', { 'flex flex-col gap-2': lines > 1 }, className)}
    >
      {Array.from({ length: lines }).map((_, index) => (
        <div
          key={index}
          style={{ height }}
          className={classNames('bg-token-gray-400 rounded-xs w-full h-3.5', lineClassName)}
        >
          {children}
        </div>
      ))}
    </div>
  );
}

export function PillSkeleton({ children, height, width, className }: SkeletonBaseProps) {
  return (
    <div
      style={{ width, height }}
      className={classNames(
        'animate-pulse rounded-lg bg-token-gray-400 px-3 h-8 w-full inline-block',
        className,
      )}
    >
      {children}
    </div>
  );
}
